<!-- vomito hematemesis ictericia -->
<template>

  <div>
    <b-card
      v-if="sintomasPrincipal.some( item => item.value === 'rejurgitacion')"
      border-variant="light"
      class="my-2"
    >
      <b-row>
        <b-col>
          <h5>Rejurgitación</h5>
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">acida:</div>
        </b-col>

        <b-col>
          <b-form-checkbox switch v-model="rejurgitacion.acida">
            {{ rejurgitacion.acida ? 'Si' : 'No' }}
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Alimentos:</div>
        </b-col>

        <b-col>
          <v-select
            placeholder="Seleccione una o mas opciones"
            :options="rejurAlimentosOpts"
            :reduce="option => option"
            label="text"
            :multiple="true"
            taggable
            @input="newArray => rejurgitacion.alimentos = onAddNewOpt(newArray)"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Frecuencia:</div>
        </b-col>

        <b-col class="col-5">
          <v-select
            placeholder="Seleccione una opcion"
            :options="rejurFrecuenciasOpts"
            :reduce="option => option"
            label="text"
            v-model="rejurgitacion.frecuencia"
          />
        </b-col>
      </b-row>

    </b-card>

    <b-card
      v-if="sintomasPrincipal.some( item => item.value === 'vomitos' )"
      border-variant="light"
      class="my-2"
    >
      <b-row>
        <b-col>
          <h5>Vomitos</h5>
        </b-col>
      </b-row>
      
      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Numero:</div>
        </b-col>

        <b-col class="col-3">
          <v-select
            placeholder="0"
            :options="cantidadOpts"
            :reduce="option => option.value"
            label="text"
            v-model="vomito.numero"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Frecuencia:</div>
        </b-col>

        <b-col class="col-5">
          <v-select
            placeholder="Seleccione una opcion"
            :options="vomitoFrecuenciasOpts"
            :reduce="option => option"
            label="text"
            v-model="vomito.frecuencia"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Contenido:</div>
        </b-col>

        <b-col>
          <b-form-input
            v-model="vomito.contenido"
            placeholder="Ingrese la descripción"
          />
        </b-col>
      </b-row>
      
    </b-card>

    <b-card 
      v-if="sintomasPrincipal.some( item => item.value === 'hematemesis' )"
      border-variant="light"
      class="my-2"
    >
      <b-row>
        <b-col>
          <h5>Hematemesis</h5>
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Precedido de:</div>
        </b-col>

        <b-col class="col-5">
          <v-select
            placeholder="Seleccione una opcion"
            :options="hemaPrecedidoOpts"
            :reduce="option => option"
            label="text"
            v-model="hema.precedido"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Numero:</div>
        </b-col>

        <b-col class="col-4">
          <v-select
            placeholder="0"
            :options="cantidadOpts"
            :reduce="option => option.value"
            label="text"
            v-model="hema.cuantas"
          />
        </b-col>
      </b-row>
      
    </b-card>

    <b-card 
      v-if="sintomasPrincipal.some( item => item.value === 'ictericia' )"
      border-variant="light"
      class="my-2"
    >
      <b-row>
        <b-col>
          <h5>Ictericia</h5>
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Desde:</div>
        </b-col>

        <b-col class="col-5">
          <v-select
            placeholder="Seleccione una opcion"
            :options="comienzoOpts"
            :reduce="option => option"
            label="text"
            v-model="ictericia.desde"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Localización:</div>
        </b-col>

        <b-col>
          <v-select
            placeholder="Seleccione una o mas opciones"
            :options="ictericiaLocalizacionOpts"
            :reduce="option => option"
            label="text"
            :multiple="true"
            taggable
            @input="newArray => ictericia.localizacion = onAddNewOpt(newArray)"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Coluria:</div>
        </b-col>

        <b-col>
          <b-form-checkbox switch v-model="ictericia.coluria">
            {{ ictericia.coluria ? 'Si' : 'No' }}
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-2 my-1">
        <b-col class="col-3">
          <div for="">Coloración de las heces:</div>
        </b-col>

        <b-col>
          <v-select
            placeholder="Seleccione una opcion"
            :options="ictericiaColorHecesOpts"
            :reduce="option => option"
            label="text"
            v-model="ictericia.color"
          />
        </b-col>
      </b-row>

    </b-card>
  </div>
  
</template>

<script>
import vSelect from 'vue-select';
import { addNewOpt } from '@/shared/helpers';

export default {

  name: 'SintomasOtros',

  components: {
    vSelect
  },

  props: {
    sintomasPrincipal: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {

      rejurgitacion: {
        acida: false,
        frecuencia: null,
        alimentos: null
      },

      vomito: {
        active: false,
        numero: null,
        frecuencia: null,
        contenido: null,
      },

      hema:{
        active: false,
        precedido: null,
        cuantas: null,
      },

      ictericia: {
        active: false,
        desde: null,
        localizacion: null,
        coluria: false,
        color: null
      },

      cantidadOpts: [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' },
        { value: 7, text: '7' },
        { value: 8, text: '8' },
        { value: 9, text: '9' },
        { value: 10, text: '+10' },
      ],

      rejurFrecuenciasOpts: [
        { value: 'todo_el_dia',      text: 'todo el dia' },
        { value: 'despues_de_comer', text: 'despues de comer' },
        { value: 'por_la_noche',     text: 'por la noche' },
        { value: 'por_la_madrugada', text: 'por la madrugada' },
      ],

      rejurAlimentosOpts: [
        { value: '', text: '' },
      ],

      vomitoFrecuenciasOpts: [
        { value: 'cada_hora',   text: 'cada hora' },
        { value: 'cada_dia',    text: 'cada dia' },
        { value: 'cada_semana', text: 'cada semana' },
        { value: 'cada_mes',    text: 'cada mes' },
      ],

      hemaPrecedidoOpts: [
        { value: 'tos',     text: 'tos' },
        { value: 'nauseas', text: 'nauseas' },
      ],

      comienzoOpts:[
        { value: 'dias',    text: 'días' },
        { value: 'semanas', text: 'semanas' },
        { value: 'meses',   text: 'meses' },
        { value: 'anios',   text: 'años' }
      ],

      ictericiaLocalizacionOpts: [
        { value: 'piel',    text: 'piel' },
        { value: 'mucosas', text: 'mucosas' },
      ],

      ictericiaColorHecesOpts: [
        { value: 'normal',    text: 'normal' },
        { value: 'hipocolia', text: 'hipocolia' },
        { value: 'acolia',    text: 'acolia' },
      ],
    }
  },

  methods: {
    onAddNewOpt( newValue ){
      return addNewOpt( newValue );
    }
  },

}
</script>
